// extracted by mini-css-extract-plugin
export default {"link":"manager_link__TYnXc","pagination":"manager_pagination__Kj2TC","container":"manager_container__XBTqV","card":"manager_card__ZUpuB","title":"manager_title__fu1Vc"};